var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": _vm.$t(_vm.isEmpty(_vm.data) ? 'ar_clinent_distributing_accounts' : 'ar_client_edit_distribution'),
      "centered": "",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": function () {
        _vm.$emit('update:visible', false);
      },
      "shown": _vm.openForm
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('validation-observer', {
    ref: "formRef"
  }, [_c('form', {
    ref: "form"
  }, [_c('b-row', {
    staticClass: "m-0 mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('ar_client_agency')
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.travelAgent,
      "disabled": true
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "margin-top": "26px"
    },
    attrs: {
      "label": _vm.$t('ar_client_total_money') + ' (VND)'
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.formatPrice(_vm.totalDistribution),
      "disabled": true
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "type": "cleave",
      "cleaveType": "uppercase",
      "label": "ar_client_distribution_code",
      "placeholder": "ar_client_distribution_code",
      "name": "distributionCode",
      "disabled": _vm.data.DistributionCode || _vm.isAutoCreateCode,
      "rules": {
        max: 13,
        min: _vm.isAutoCreateCode ? 0 : 2,
        code: !_vm.isAutoCreateCode,
        required: !_vm.isAutoCreateCode
      }
    },
    model: {
      value: _vm.distributionCode,
      callback: function ($$v) {
        _vm.distributionCode = $$v;
      },
      expression: "distributionCode"
    }
  }), _c('div', {
    staticClass: "d-flex align-items-center mt-2 mb-2"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_auto_create_distribution_code")))]), _c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.data.DistributionCode,
      "switch": ""
    },
    model: {
      value: _vm.isAutoCreateCode,
      callback: function ($$v) {
        _vm.isAutoCreateCode = $$v;
      },
      expression: "isAutoCreateCode"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": _vm.$t('ar_client_allotment') + ':',
      "label-cols": "3"
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "disabled": true,
      "aria-describedby": _vm.ariaDescribedby,
      "name": "some-radios",
      "value": "AUTO"
    },
    model: {
      value: _vm.selectedDistributionType,
      callback: function ($$v) {
        _vm.selectedDistributionType = $$v;
      },
      expression: "selectedDistributionType"
    }
  }, [_vm._v(_vm._s(_vm.$t("ar_client_auto")))]), _c('b-form-radio', {
    attrs: {
      "disabled": _vm.disabledField,
      "aria-describedby": _vm.ariaDescribedby,
      "name": "some-radios",
      "value": "Manual"
    },
    model: {
      value: _vm.selectedDistributionType,
      callback: function ($$v) {
        _vm.selectedDistributionType = $$v;
      },
      expression: "selectedDistributionType"
    }
  }, [_vm._v(_vm._s(_vm.$t("ar_client_manual")))])], 1)])], 1)], 1)], 1), _c('div', {
    staticClass: "p-1"
  }, [_c('FormItem', {
    attrs: {
      "type": "string",
      "variant": "textarea",
      "label": "ar_client_note",
      "placeholder": "ar_client_note",
      "name": "note",
      "rules": {
        max: 255
      }
    },
    model: {
      value: _vm.note,
      callback: function ($$v) {
        _vm.note = $$v;
      },
      expression: "note"
    }
  })], 1)]), _c('h6', {
    staticClass: "m-2"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_list_debit_account")))]), _c('b-row', {
    staticClass: "m-0"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('ar_client_debit_account')
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.disabledField,
      "label": "AccountCode",
      "placeholder": _vm.$t('golf_ar_select_debit_account'),
      "options": _vm.listAccountClient
    },
    model: {
      value: _vm.selectedValAccount,
      callback: function ($$v) {
        _vm.selectedValAccount = $$v;
      },
      expression: "selectedValAccount"
    }
  }, [_c('div', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_no_data")))])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('FormItem', {
    attrs: {
      "disabled": _vm.disabledField,
      "type": "cleave",
      "cleaveType": "currency",
      "label": "ar_client_distribution_amount",
      "placeholder": " ",
      "name": "valMoney",
      "rules": {
        max: 12
      }
    },
    model: {
      value: _vm.valMoney,
      callback: function ($$v) {
        _vm.valMoney = $$v;
      },
      expression: "valMoney"
    }
  }), _vm.valMoney ? _c('div', {
    staticClass: "text-right font-weight-bold font-italic text-primary",
    staticStyle: {
      "font-size": "10px",
      "margin-top": "6px"
    }
  }, [_vm._v(" " + _vm._s(_vm.numberToVnText(this.valMoney)) + " ")]) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "disabled": _vm.disabledField,
      "variant": "primary"
    },
    on: {
      "click": _vm.addListArAccount
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_add")) + " ")])], 1)], 1), _c('div', {
    staticClass: "p-1"
  }, [_c('EzTable', {
    ref: "tableRef",
    attrs: {
      "forceDisplayActions": true,
      "toolbarConfig": {
        disableToolbar: true
      },
      "pageConfig": {
        disablePagination: true
      },
      "actions": _vm.actions,
      "columns": _vm.columns,
      "editable": true,
      "data-source": _vm.listDistributionAdded
    },
    on: {
      "onEditorPreparing": _vm.onEditorPreparing,
      "action-1": _vm.removeItemList
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2 mr-4"
  }, [_c('h5', {
    staticClass: "mr-1",
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_clinent_total_amount_distributed")) + " (VND) : ")]), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "1px"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalMoneyDistribution)))])]), _c('LoadingModalButton', {
    ref: "buttonRef",
    attrs: {
      "usingTimeOutSubmit": true,
      "className": " mb-2 mr-2"
    },
    on: {
      "click": _vm.acceptData
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_common_save")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }